import { Box, Typography } from '@mui/material';
import fakeData from 'features/IRWorkstation/constants/fakeData';

const IntegrationStrip = () => {
	const { integrationStrip: data } = fakeData;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: '10px',
				px: '18px',
				height: 28,
				backgroundColor: 'vdr.bg',
				borderBottom: '0.5px solid',
				borderColor: 'vdr.border',
			}}
		>
			{/* pulsing dot */}
			<Box
				sx={{
					width: 7,
					height: 7,
					borderRadius: '50%',
					backgroundColor: 'vdr.accent',
					animation: 'pulse 2s infinite',
					'@keyframes pulse': {
						'0%, 100%': { opacity: 1 },
						'50%': { opacity: 0.4 },
					},
				}}
			/>
			<Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'vdr.text' }}>
				{data.label}
			</Typography>
			<Typography sx={{ fontSize: '11px', color: 'vdr.border' }}>·</Typography>
			<Typography sx={{ fontSize: '11px', color: 'vdr.text' }}>
				{data.status}
			</Typography>
			<Typography sx={{ fontSize: '11px', color: 'vdr.border' }}>·</Typography>
			<Typography sx={{ fontSize: '11px', color: 'vdr.text' }}>
				{data.signals}
			</Typography>
			<Typography sx={{ fontSize: '11px', color: 'vdr.border' }}>·</Typography>
			<Typography sx={{ fontSize: '11px', color: 'vdr.text' }}>
				{data.lastSignal}
			</Typography>
			{/* spacer with flex 1 to push the below button to the far right */}
			<Box sx={{ flex: 1 }} />
			<Box
				component='button'
				sx={{
					fontSize: '11px',
					fontWeight: 600,
					color: 'vdr.text',
					background: 'transparent',
					border: '0.5px solid',
					borderColor: 'vdr.border',
					borderRadius: '5px',
					padding: '3px 10px',
					cursor: 'pointer',
					fontFamily: 'inherit',
					'&:hover': { backgroundColor: 'vdr.hover' },
				}}
			>
				Open Raise VDR →
			</Box>
		</Box>
	);
};

export default IntegrationStrip;
